module.exports = __webpack_public_path__ + "img/benefit_tiers.19ad4e2e.png";